module.exports = __webpack_public_path__ + "img/comerciante.38ebae2e.png";